export default "__VITE_ASSET__BNoq01z1__"